import region from "../utils/region.js";

import {
  TULA,
  SARATOV
}                   from '@/config/region';

/* подстановочные тексты .. для регионов ...*/

// для компонента ObjectUpdate
export const ObjectUpdate = {
  part_fuel_production: region.getRegionConfig({
    default: 'Доля отбора полезных фракций для компостирования и производства RDF-топлива',
    [TULA]: 'Доля отбираемых полезных фракций',
    [SARATOV]: 'Доля отбираемых полезных фракций',
  })
}